import { spaceCadet } from '@cogneed/react-utils';
import { alpha } from '@mui/material';

export const scrollbarStyle1 = {
  '&::-webkit-scrollbar': {
    width: 10,
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: spaceCadet[100],
  },

  '&::-webkit-scrollbar-thumb': {
    background: alpha(spaceCadet[400], 0.5),
    borderRadius: 10,
    '&:hover': {
      background: alpha(spaceCadet[400], 0.75),
    },
  },
};

export const scrollbarStyle2 = {
  '&::-webkit-scrollbar': {
    width: 10,
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: spaceCadet[100],
  },

  '&::-webkit-scrollbar-thumb': {
    background: spaceCadet[300],
    borderRadius: 10,
    '&:hover': {
      background: alpha(spaceCadet[400], 0.6),
    },
  },
};

export const scrollbarStyle3 = {
  '&::-webkit-scrollbar': {
    height: 8,
  },

  '&::-webkit-scrollbar-thumb': {
    background: spaceCadet[300],
    borderRadius: 10,
    '&:hover': {
      background: alpha(spaceCadet[400], 0.6),
    },
  },
};

export const scrollbarStyle4 = {
  ...scrollbarStyle2,

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'white',
  },
};
